define('rebrush/components/blocks/raster-grid/tiles/helpers/image/center',[
    'jquery',
    'cartware/jquery/bem',
    'lodash',
    'fastdom'
], function(
    $,
    BEM,
    _,
    fastdom
) {
    var sourcesCache = {};

    function Helper(block) {
        this.block = BEM.block(block);
        this.image = this.block.getElements('image');

        this.layout();
    }

    Helper.prototype = {
        layout: function() {


            return;


            setTimeout(_.bind(function() {
                var currentSrc = this.image.get(0).currentSrc || this.image.get(0).src;

                var tick = _.bind(function(dimensions) {
                    fastdom.measure(_.bind(function() {
                        var width = this.block.width(),
                            height = this.block.height();

                        // CSS assigns the image a width of 100 %
                        if (dimensions[0] !== width) {
                            var q = dimensions[0] / width;
                            dimensions = _.map(dimensions, function(val) {
                                return val / q;
                            });
                        }

                        var targetLeft = Math.floor((dimensions[0] - width) / -2),
                            targetTop = Math.floor((dimensions[1] - height) / -2);

                        fastdom.mutate(_.bind(function() {
                            this.image.css({
                                left: targetLeft,
                                top: targetTop
                            });
                        }, this));
                    }, this));
                }, this);

                console.log(this.image.get(0), this.image.get(0).currentSrc);

                if (currentSrc in sourcesCache) {
                    tick(sourcesCache[currentSrc]);
                } else {
                    var tmpImage = new Image();
                    tmpImage.onload = function() {
                        var dimensions = [tmpImage.width, tmpImage.height];
                        sourcesCache[currentSrc] = dimensions;
                        tick(dimensions);
                    };
                    tmpImage.src = currentSrc;
                }
            }, this), 2000);
        }
    };

    return Helper;
});
